import React, { useEffect, useState } from "react";

import * as S from "../../constants/StringConstants";

import { useDispatch, useSelector } from "react-redux";
import PromptModal from "src/components/ConfirmationModal/PromptModalV2";
import { IRootState } from "src/store/reducers";

import Dropzone from "react-dropzone";
import { Form as FinalForm } from "react-final-form";
import SingleSelectField from "src/components/Form/SingleSelectFieldV2/SingleSelectField";
import Icon, { IconName } from "src/components/Icon/Icon";
import { useLoading } from "src/hooks/useLoading";
import { fetchApplicationOptions } from "src/store/reducers/applicationBuilder";
import { addDefaultOption } from "src/util/utils.defaultValues";
import "./UploadModal.scss";

const selectCarrierTypeList = [
  // {
  //     "key": "MassMutual",
  //     "value": 37
  // },
  {
    key: "The Standard",
    value: 288,
  },
  {
    key: "Ameritas",
    value: 397,
  },
];

const selectBranchList = [
  {
    key: "San Diego",
    value: 1,
  },
  {
    key: "Kansas City",
    value: 2,
  },
  {
    key: "Phoenix",
    value: 3,
  },
  {
    key: "New England",
    value: 4,
  },
  {
    key: "Baltimore",
    value: 105,
  },
  {
    key: "Denver",
    value: 107,
  },
  {
    key: "Dallas",
    value: 108,
  },
  {
    key: "New Jersey",
    value: 109,
  },
];

interface UploadModalData {
  carrierTypeId: string;
  branchTypeId: string;
  statusTypeId: string;
  file: File;
}

interface UploadModalProps {
  handleConfirm: (data: UploadModalData) => void;
  handleReject: () => void;
  errorMessage?: string | null;
}

export const UploadModal = (props: UploadModalProps) => {
  const [files, setFiles] = useState<File[]>([]);
  const [validationOk, setValidationOk] = useState(false);
  const dispatch = useDispatch();
  const { handleReject } = props;

  useEffect(() => {
    if (open) {
      dispatch(fetchApplicationOptions());
    }
  }, [open]);

  const { statusOptions } = useSelector((state: IRootState) => ({
    loading: state.applicationBuilder.loading,
    //carrierOptions: addDefaultOption("", state.applicationBuilder.selectCarrierTypeList),
    // branchOptions: addDefaultOption("", state.applicationBuilder.selectBranchList),
    statusOptions: addDefaultOption("", state.applicationBuilder.selectStatusList),
  }));

  const handleConfirm = values => {
    const { carrier, branch, status } = values;
    const data = { carrierTypeId: carrier, branchTypeId: branch, statusTypeId: status, file: files[0] };
    props.handleConfirm(data);
  };

  const handleDrop = (accepted, rejected) => {
    if (accepted.length > 0) {
      setFiles([...files, ...accepted]);
    }
  };

  const handleFileDelete = index => {
    setFiles(files.slice(0, index).concat(files.slice(index + 1)));
  };

  // using validate to set the ok flag to disable submit button
  const handleValidate = values => {
    const { carrier, branch, status } = values;
    setValidationOk(carrier && branch && status && files.length > 0);
    return {};
  };

  const { isLoading } = useLoading();

  return (
    <FinalForm onSubmit={() => {}} initialValues={{}} validate={handleValidate}>
      {formProps => {
        return (
          <PromptModal<UploadModalData>
            open={true}
            title={S.APP_UPLOAD}
            confirmText={S.APP_CONFIRM_BUTTON}
            rejectText={S.APP_CANCEL_BUTTON}
            onReject={handleReject}
            onConfirm={() => handleConfirm(formProps.values)}
            confirmDisabled={!validationOk || isLoading}
            isLoading={isLoading}>
            {props.errorMessage && <div className="upload-modal__error">{props.errorMessage}</div>}
            <div className="upload-modal">
              <div className="convert-modal__card_container">
                <form onSubmit={formProps.handleSubmit} className="upload-modal__form">
                  <SingleSelectField
                    options={addDefaultOption("", selectCarrierTypeList)}
                    name="carrier"
                    label={S.APP_UPLOAD_MODAL_CARRIER}
                  />
                  <SingleSelectField
                    options={addDefaultOption("", selectBranchList)}
                    name="branch"
                    label={S.APP_UPLOAD_MODAL_ORG}
                  />
                  <SingleSelectField options={statusOptions} name="status" label={S.APP_UPLOAD_MODAL_STATUS} />
                  <div>
                    <label>{S.APP_UPLOAD_MODAL_FILE}</label>
                    <Dropzone onDrop={handleDrop}>
                      {({ getRootProps, getInputProps, isDragActive }) => (
                        <div className={`dropzone ${isDragActive ? "active" : ""}`} {...getRootProps()}>
                          <input {...getInputProps()} />
                          <p>
                            {S.UDM_DROPZONE_1}
                            <br />
                            {S.UDM_DROPZONE_2}
                          </p>
                        </div>
                      )}
                    </Dropzone>
                    {formProps.error && formProps.dirty && <div className="dropzone__error">{formProps.error}</div>}
                    <div className="files">
                      {files.map((file, index) => {
                        return (
                          <div key={`${file.name}-${index}`} className="file">
                            {file.name}
                            <button onClick={() => handleFileDelete(index)}>
                              <Icon name={IconName.Close} size="16px" />
                            </button>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </PromptModal>
        );
      }}
    </FinalForm>
  );
};
